module.exports = __webpack_public_path__ + "static/kparikh9github-a0db2e9803d43ae44e18bc2fc81b25ca.pdf";